exports = module.exports = require("../../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".teacherList {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n}\n.teacherList .teacherList-left,\n.teacherList .teacherList-right {\n  width: 35px;\n  cursor: pointer;\n}\n.teacherList .teacherList-left {\n  background: url(https://static.cleanlive.cn/user-center/images/prev.png) no-repeat center;\n  background-size: contain;\n}\n.teacherList .teacherList-right {\n  background: url(https://static.cleanlive.cn/user-center/images/next.png) no-repeat center;\n  background-size: contain;\n}\n@media screen and (max-width: 1200px) {\n  .teacherList .ant-carousel {\n    width: 560px !important;\n  }\n  .teacherList .ant-carousel .teacherList-teacher {\n    width: 180px !important;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?{"importLoaders":1}!./node_modules/_postcss-loader@2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/teacherList/index.less
// module id = 1013
// module chunks = 0